import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { document, create_batch, create_weighment } from './api';

const initialState = {
  allMaterials: [],
  material: {},
  pagination: [],
  getAllMaterilLoading: null,
  MaterialsList: [],
  suppliers: []
};

const actions = {
  GET_ALL_MATERIALS: 'damage/GET_ALL_MATERIALS',
  GET_DOCS_BY_ID: 'damage/GET_DOCS_BY_ID',
  CREATE_WEIGHMENT_REPORT: 'damage/CREATE_WEIGHMENT_REPORT'
};

export const getDocsbyId = createAsyncThunk(
  actions.GET_DOCS_BY_ID,
  async (payload) => {
    const response = await document('all', payload);

    return response;
  }
);

export const createBatch = createAsyncThunk(
  actions.CREATE_MATERIAL,
  async (payload) => {
    const response = await create_batch('create', payload);
    return response;
  }
);

export const createWeighmentReport = createAsyncThunk(
  actions.CREATE_WEIGHMENT_REPORT,
  async (payload) => {
    const response = await create_weighment('add', payload);
    return response;
  }
);

export const damageSlice = createSlice({
  name: 'damage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocsbyId.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(getDocsbyId.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, data } = action.payload;
        if (success) {
          state.material = data;
        } else {
          state.material = '';
        }
      })
      .addCase(getDocsbyId.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });

    builder
      .addCase(createBatch.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(createBatch.fulfilled, (state) => {
        state.getAllMaterilLoading = false;

        // const { success, message: msg } = action.payload;
        // if (!success) {
        //   message.error(msg);
        // }
      })
      .addCase(createBatch.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });
    builder
      .addCase(createWeighmentReport.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(createWeighmentReport.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { sucess, message: msg } = action.payload;
        if (!sucess) {
          message.error(msg);
        }
      })
      .addCase(createWeighmentReport.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });
  }
});
export default damageSlice.reducer;
